import { produce } from 'immer';
import { createStore } from './Store';

/**
 * Store to hold all opened modals
 *
 * This allows them to be closed properly with escape key
 */
export interface OpenedModalsStore {
  /**
   * Keeps track of all the opened modals via their ids
   */
  openedModalsIds: Array<string>;
  /**
   * Adds a modal id to the list if it's not already included
   */
  addOpenedModal(id: string): void;
  /**
   * Removes an entry from openedModalsIds list by id
   */
  removeOpenedModal(id: string): void;
}

export const [
  useOpenedModalsStore,
  OpenedModalsStoreApi
] = createStore<OpenedModalsStore>('openedmodals.store', (set, get) => ({
  openedModalsIds: [],
  addOpenedModal(modalId: string): void {
    set(
      produce((state: OpenedModalsStore) => {
        if (!state.openedModalsIds.includes(modalId)) {
          state.openedModalsIds.push(modalId);
        }
      })
    );
  },
  removeOpenedModal(id): void {
    set(
      produce((state: OpenedModalsStore) => {
        state.openedModalsIds.splice(state.openedModalsIds.indexOf(id), 1);
      })
    );
  }
}));
